import { Component, Input } from '@angular/core';

@Component({
    selector: 'search-result-site',
    templateUrl: './searchResultSite.component.html',
    standalone: false
})
export class SearchResultSiteComponent {
    @Input() result;
}
